import { useEffect, useState } from "react";
import { authService } from "../../api/authService";
import Logo from '../../assets/icons/logo.svg';
import Icon from "../Icon";
import Modal from "../Modal";
import styles from './index.module.scss';

interface JoinBetaModalProps {
    showModal: boolean;
    onClose: () => void;
}

const JoinBetaModal = ({ showModal, onClose }: JoinBetaModalProps) => {
    const [showInviteCode, setShowInviteCode] = useState(false);
    const [inviteCode, setInviteCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleInviteCodeSubmit = async () => {
        if (!inviteCode.trim()) {
            setError('Please enter an invite code');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            const result = await authService.redeemInviteCode(inviteCode);
            if (result.success) {
                window.location.href = '/admin';
            } else {
                setError('Invalid code. Please check it or request a new one.');
            }
        } catch (err) {
            setError('Invalid code. Please check it or request a new one.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleHaveCode = () => {
        setShowInviteCode(true);
        setError(''); // 清除之前的错误
        setInviteCode(''); // 清除之前的输入
    };

    const handleRequestInvite = () => {
        window.open('https://form.typeform.com/to/YUFCEQXt', '_blank');
    };

    useEffect(() => {
        setShowInviteCode(false);
    }, [showModal])

    if (!showModal) return null;

    return (
        <Modal onClose={onClose}>
            <div className={styles.modalContent}>
                <div className={styles.logo}>
                    <img src={Logo} alt="Bustly" />
                </div>
                

                {/* Title */}
                <h2 className={styles.title}>Join Our Beta Tester Program</h2>
                
                {/* Description */}
                <p className={styles.description}>
                    We're in private beta and actively testing. Join us—your feedback shapes Bustly
                </p>

                {/* Benefits Section */}
                <div className={styles.benefitsSection}>
                    <h3 className={styles.benefitsTitle}>You'll get:</h3>
                    <div className={styles.benefitsList}>
                        <div className={styles.benefitItem}>
                            <Icon name="check" size={20} />
                            <span>Early access to Bustly AI commerce agent</span>
                        </div>
                        <div className={styles.benefitItem}>
                            <Icon name="check" size={20} />
                            <span>14-day free trial — 0% take rate during your trial</span>
                        </div>
                        <div className={styles.benefitItem}>
                            <Icon name="check" size={20} />
                            <span>1:1 consultation and support, plus early features</span>
                        </div>
                        <div className={styles.benefitItem}>
                            <Icon name="check" size={20} />
                            <span>Direct influence on what we build next</span>
                        </div>
                        <div className={styles.benefitItem}>
                            <Icon name="check" size={20} />
                            <span>Gifts/credits for helpful suggestions</span>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                {!showInviteCode ? (
                    <div className={styles.buttonGroup}>
                        <button
                            className={styles.inviteCodeButton}
                            onClick={handleHaveCode}
                        >
                            I have invite code
                        </button>
                        <button
                            className={styles.joinButton}
                            onClick={handleRequestInvite}
                        >
                            Join Beta Now
                        </button>
                    </div>
                ) : (
                    <div className={styles.inviteCodeSection}>
                        <div className={styles.inputGroup}>
                            <input
                                type="text"
                                value={inviteCode}
                                onChange={(e) => setInviteCode(e.target.value)}
                                placeholder="Enter your invite code"
                                className={`${styles.inviteCodeInput} ${error ? styles.inputError : ''}`}
                            />
                            <button
                                className={styles.submitButton}
                                onClick={handleInviteCodeSubmit}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Verifying...' : 'Submit Invite Code'}
                            </button>
                        </div>
                        
                        {error ? (
                            <div className={styles.errorContainer}>
                                <span className={styles.errorMessage}>{error}</span>
                                <a
                                    onClick={handleRequestInvite}
                                    className={styles.requestInviteLink}
                                >
                                    Request an invite
                                </a>
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default JoinBetaModal; 